import React, { useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import $ from "jquery";
import "../../assets/css/owl.carousel.css";
import "../../assets/css/owl.theme.default.min.css";
import { FiChevronRight } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GetInTouchButton from "../../components/about/GetInTouchButton";
import "./HeroSlider.css";


export default function HeroSlider({ slideItems }) {
  const carouselRef = useRef(null);
  const isAutoplayPausedRef = useRef(false);
  const buttonRef = useRef(null);

  const handlePausePlay = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    if (carouselRef.current && carouselRef.current.$ele) {
      const $carousel = carouselRef.current.$ele;
      const owlCarousel = $carousel.data("owl.carousel");

      if (owlCarousel && owlCarousel._plugins) {
        const autoplayPlugin = owlCarousel._plugins.autoplay;

        if (autoplayPlugin) {
          if (isAutoplayPausedRef.current) {
            console.log("resuming autoplay - calling play()");
            if (typeof autoplayPlugin.play === "function") {
              autoplayPlugin.play();
            }
            isAutoplayPausedRef.current = false;
            if (buttonRef.current) {
              buttonRef.current.textContent = "⏸ Pause";
              buttonRef.current.setAttribute("aria-pressed", "false");
              buttonRef.current.setAttribute("aria-label", "Pause carousel");
              buttonRef.current.setAttribute("title", "Pause carousel");
            }
          } else {
            console.log("pausing autoplay - calling pause()");
            if (typeof autoplayPlugin.pause === "function") {
              autoplayPlugin.pause();
            }
            isAutoplayPausedRef.current = true;
            if (buttonRef.current) {
              buttonRef.current.textContent = "▶ Play";
              buttonRef.current.setAttribute("aria-pressed", "true");
              buttonRef.current.setAttribute("aria-label", "Play carousel");
              buttonRef.current.setAttribute("title", "Play carousel");
            }
          }
        }
      }
    }
  }, []);

  return (
    <section className="hero-slider-wrapper">
          <ToastContainer />
      <div className="carousel-controls">
        <button
          ref={buttonRef}
          className="carousel-pause-play-btn"
          onClick={handlePausePlay}
          aria-label="Pause carousel"
          aria-pressed="false"
          title="Pause carousel"
        >
          ⏸ Pause
        </button>
      </div>
      <OwlCarousel
        ref={carouselRef}
        className="owl-theme"
        loop={true}
        autoplay={true}
        autoplayTimeout={5000}
        autoplayHoverPause={true}
        margin={10}
        dots={false}
        // nav
        items={1}
      >
        {slideItems.map((item, index) => {
          return (
            <div
              key={index}
              className="hero-slider-item"
              style={{ backgroundImage: "url(" + item.bg + ")" }}
            >
              <div className="container">
                <div className="row">
                  <div className={"col-" + item.col}>
                    <div className="hero-slider-content">
                      {item.title ? <h1>{item.title}</h1> : ""}
                      {item.description ? <p>{item.description}</p> : ""}
                    </div>
                    {/* <div className="cta-buttons">
                      <Link
                        to={"/about"}
                        className="theme-button"
                        style={{ backgroundColor: "#C39239" }}
                      >
                        Know about us <FiChevronRight className="icon" />
                      </Link>
                    </div> */}
                    {/* <div  className="touch_form">
        <GetInTouchButton />
        </div> */}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </OwlCarousel>
    </section>
  );
}
